import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking, composeAttrsForClickTracking } from "../../utils/tracking";
import { SHOW_LIST_CLICK_ID, SHOW_MAP_CLICK_ID } from "./const";
import type { View } from "../map/types";
$ const { expandedView } = input;
$ const isMapExpanded = expandedView === "map";
export interface Input extends Marko.HTML.Div {
  expandedView: View;
  "on-toggle-view": () => void;
}

<ebay-button
  ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(isMapExpanded ? SHOW_LIST_CLICK_ID : SHOW_MAP_CLICK_ID, "button") }])
  class="toggle-view-btn"
  data-testid="map-toggle-view-btn"
  size="large"
  priority="primary"
  on-click("emit", "toggle-view")
>
  <if(isMapExpanded)>
    <ebay-list-view-filled-16-icon/>
    <fe-textual-display model=t("mapview/map", "showListToggleLabel")/>
  </if>
  <else>
    <ebay-map-16-icon/>
    <fe-textual-display model=t("mapview/map", "showMapToggleLabel")/>
  </else>
</ebay-button>
